// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../platform/@jutro/cli-app/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../platform/@jutro/cli-app/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app__YourHomePage__errorInline{color:var(--GW-COLOR-ERROR)}", "",{"version":3,"sources":["webpack://./node_modules/gw-capability-quoteandbind-ho-react/pages/YourHome/YourHomePage.module.scss"],"names":[],"mappings":"AAAA,gCACI,2BAAA","sourcesContent":[".errorInline {\n    color: var(--GW-COLOR-ERROR);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorInline": "app__YourHomePage__errorInline"
};
export default ___CSS_LOADER_EXPORT___;
